export default __webpack_public_path__ + "static/media/photo-15.5fd4d8a3.jpeg";